import { useContext } from 'react';
import { useNavigate } from 'react-router-dom';

import i18n from '@nextroll/ar-i18n';

import ThemeWrapperContext from '../../../contexts/ThemeWrapperContext';
import PageBanner from '../PageBanner';

const CancelledView = () => {
    const { supportEmail } = useContext(ThemeWrapperContext);
    const navigate = useNavigate();
    const navigateToChangeEmail = () => navigate('../change-email');

    const topText = i18n.gettext('Email verification link cancelled');
    const bottomText = i18n.gettext(
        'Looks like the verification link has been cancelled because the email address has been changed. Here are a few options that might help:'
    );

    const options = [
        i18n.gettext(
            'Check the inbox of the new email address entered for the verification link'
        ),
        i18n.gettext(
            'Re-enter your email <Link>here</Link> if the one you entered was incorrect',
            {
                Link: <a onClick={navigateToChangeEmail} />,
            }
        ),
        i18n.gettext(
            'Still having trouble? Reach out to <LINK>{{supportEmailAddress}}</LINK> or your Account Executive.',
            {
                LINK: <a href={`mailto:${supportEmail}`} target='_blank' />,
                supportEmailAddress: supportEmail,
            }
        ),
    ];

    return (
        <div className='eh-ev-form-view-cancelled'>
            <PageBanner
                topText={topText}
                bottomText={bottomText}
                className='status-cancelled'
            />
            <ul className='eh-ev-bottom-text'>
                {options.map((option) => (
                    <li key={option}>
                        <span>{option}</span>
                    </li>
                ))}
            </ul>
        </div>
    );
};

export default CancelledView;
